import { store } from "../store/store";
import { refresh } from "../store/common/refresh";

export const refreshReq = socket => {
  socket.on("refreshRequest", data => {
    if ("appointment" in data && data.appointment !== false) {
      // Remove the same appointment if added before for edge case
      store.commit("removeFromAppointmentList", {
        date: data.appointment["app_date"],
        id: isNaN(data.appointment.id) ? 0 : parseInt(data.appointment.id)
      });

      // Adding the appointment
      store.commit("addOrderedNextAppointmentForDate", {
        appointment: data.appointment,
        selectedProviderId: data["user_id"],
        isEdit: "is_edit" in data ? data["is_edit"] : false
      });
      store.commit("addDetails", data.appointment); // Adding to details
    } else {
      // If delete is required then we delete the appointments
      if ("delete_required" in data && data["delete_required"] !== false) {
        refresh.deleteRequired(
          data["delete_required"],
          store,
          data["user_id"],
          data["deleteOrCancel"]
        );
      }

      // If refresh is required we refresh the dates
      if ("refresh_required" in data && data["refresh_required"] !== false) {
        refresh.refreshRequired(
          data["refresh_required"],
          store,
          data["user_id"]
        );
      }

      // Refresh total is first deleting and then refreshing
      if ("refresh_total" in data && data["refresh_total"] !== false) {
        // Step 1: Delete the appointments
        refresh.deleteRequired(data["refresh_total"], store, data["user_id"]);

        // Step 2: Refresh the dates
        refresh.refreshRequired(
          data["refresh_total"].map(appointment => {
            return appointment["app_date"];
          }),
          store,
          data["user_id"]
        );
      }
    }
  });
};
